import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import DataPickerCst from "@components/InputCst/DataPickerCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";
import ToggleSection from "./ToggleSection";

interface PublicationSectionProps extends WizardStepProps<ActivityWizardData> {
  locked?: boolean;
}

const PublicationSection: React.FC<PublicationSectionProps> = ({
  data,
  setData,
  errors,
  locked = false,
}) => {
  const { t } = useTranslation("wizard-activity");

  const errMsg = (key: string): string =>
    errors[key] ? t(`errors.${errors[key]}`) || "" : "";

  const handleScheduleToggle = (next: boolean) => {
    if (next) {
      setData({ schedule_publication: true, publish_date: null });
    } else {
      setData({
        schedule_publication: false,
        publish_date: new Date().toISOString(),
      });
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <ToggleSection
        question={t("sections.publication.question")}
        description={t("sections.publication.description") || undefined}
        checked={data.schedule_publication}
        onChange={handleScheduleToggle}
        noLabel={t("common.no") || "No"}
        yesLabel={t("common.yes") || "Sì"}
        disabled={locked}
      />

      {data.schedule_publication && (
        <Box>
          <DataPickerCst
            id="activity-publish-date"
            label={`${t("fields.publish-date")} *`}
            value={data.publish_date ?? null}
            onChange={(value: any) =>
              setData({
                publish_date: value ? new Date(value).toISOString() : null,
              })
            }
            error={!!errors.publish_date}
            errorMessage={errMsg("publish_date")}
            disabled={locked}
          />
        </Box>
      )}

      {/* TODO: data di obsolescenza temporaneamente nascosta — riabilitare
          quando si vorrà esporla. La validation in `validateMainInfo.ts`
          è già coordinata */}
      {/*
      <Box>
        <DataPickerCst
          id="activity-obsolescent-date"
          label={`${t("fields.obsolescent-date")} *`}
          value={data.obsolescent_date ?? null}
          onChange={(value: any) =>
            setData({
              obsolescent_date: value ? new Date(value).toISOString() : null,
            })
          }
          error={!!errors.obsolescent_date}
          errorMessage={errMsg("obsolescent_date")}
        />
      </Box>
      */}
    </Box>
  );
};

export default PublicationSection;
